var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c(
        "q-field",
        {
          attrs: {
            label: !_vm.hideLabel ? _vm.$t("bank_details") : "",
            labelWidth: 2,
            icon: _vm.showIcon ? "account_balance" : undefined,
            error: _vm.errors.has("accountNumber_" + _vm.id),
            "error-label": _vm.errors.first("accountNumber_" + _vm.id)
          }
        },
        [
          _c("q-input", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate.disable",
                value: "iban|max:255",
                expression: "'iban|max:255'",
                modifiers: { disable: true }
              }
            ],
            attrs: {
              name: "accountNumber_" + _vm.id,
              "data-vv-as": _vm.$t("account_number"),
              placeholder: _vm.$t("account_number")
            },
            model: {
              value: _vm.bankDetails.accountNumber,
              callback: function($$v) {
                _vm.$set(_vm.bankDetails, "accountNumber", $$v)
              },
              expression: "bankDetails.accountNumber"
            }
          })
        ],
        1
      ),
      _vm.bankDetails.accountNumber || _vm.expanded
        ? [
            _c("q-field", { attrs: { inset: _vm.inset, labelWidth: 2 } }, [
              _c("div", { staticClass: "row gutter-sm" }, [
                _c(
                  "div",
                  { staticClass: "col-sm-4 col-12 q-mb-sm" },
                  [
                    _c(
                      "q-field",
                      {
                        staticClass: "no-margin",
                        attrs: {
                          error: _vm.errors.has("accountOwner_" + _vm.id),
                          "error-label": _vm.errors.first(
                            "accountOwner_" + _vm.id
                          )
                        }
                      },
                      [
                        _c("q-input", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate.disable",
                              value: "max:255",
                              expression: "'max:255'",
                              modifiers: { disable: true }
                            }
                          ],
                          attrs: {
                            name: "accountOwner_" + _vm.id,
                            "data-vv-as": _vm.$t("account_owner"),
                            placeholder: _vm.$t("account_owner")
                          },
                          model: {
                            value: _vm.bankDetails.accountOwner,
                            callback: function($$v) {
                              _vm.$set(_vm.bankDetails, "accountOwner", $$v)
                            },
                            expression: "bankDetails.accountOwner"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-sm-4 col-12 q-mb-sm" },
                  [
                    _c(
                      "q-field",
                      {
                        staticClass: "no-margin",
                        attrs: {
                          error: _vm.errors.has("bankName_" + _vm.id),
                          "error-label": _vm.errors.first("bankName_" + _vm.id)
                        }
                      },
                      [
                        _c("q-input", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate.disable",
                              value: "max:255",
                              expression: "'max:255'",
                              modifiers: { disable: true }
                            }
                          ],
                          attrs: {
                            name: "bankName_" + _vm.id,
                            "data-vv-as": _vm.$t("bank_name"),
                            placeholder: _vm.$t("bank_name")
                          },
                          model: {
                            value: _vm.bankDetails.bankName,
                            callback: function($$v) {
                              _vm.$set(_vm.bankDetails, "bankName", $$v)
                            },
                            expression: "bankDetails.bankName"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-sm-4 col-12 q-mb-sm" },
                  [
                    _c(
                      "q-field",
                      {
                        staticClass: "no-margin",
                        attrs: {
                          error: _vm.errors.has("bankIdentifier_" + _vm.id),
                          "error-label": _vm.errors.first(
                            "bankIdentifier_" + _vm.id
                          )
                        }
                      },
                      [
                        _c("q-input", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate.disable",
                              value: "max:255",
                              expression: "'max:255'",
                              modifiers: { disable: true }
                            }
                          ],
                          attrs: {
                            name: "bankIdentifier_" + _vm.id,
                            "data-vv-as": _vm.$t("bank_identifier"),
                            placeholder: _vm.$t("bank_identifier")
                          },
                          model: {
                            value: _vm.bankDetails.bankIdentifier,
                            callback: function($$v) {
                              _vm.$set(_vm.bankDetails, "bankIdentifier", $$v)
                            },
                            expression: "bankDetails.bankIdentifier"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ]),
            _c(
              "q-field",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.bankDetails.accountNumber && _vm.label,
                    expression: "bankDetails.accountNumber && label"
                  }
                ],
                attrs: {
                  inset: _vm.inset,
                  labelWidth: 2,
                  error: _vm.errors.has("bankDetailsLabel_" + _vm.id),
                  "error-label": _vm.errors.first("bankDetailsLabel_" + _vm.id)
                }
              },
              [
                _c("q-input", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate.disable",
                      value: "max:255",
                      expression: "'max:255'",
                      modifiers: { disable: true }
                    }
                  ],
                  attrs: {
                    name: "bankDetailsLabel_" + _vm.id,
                    "data-vv-as": _vm.$t("label"),
                    placeholder: _vm.$t("label")
                  },
                  model: {
                    value: _vm.bankDetails.label,
                    callback: function($$v) {
                      _vm.$set(_vm.bankDetails, "label", $$v)
                    },
                    expression: "bankDetails.label"
                  }
                })
              ],
              1
            )
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }